// extracted by mini-css-extract-plugin
export var form = "formik-form-module--form--E7oYi";
export var globalError = "formik-form-module--global-error--I+fm-";
export var loader = "formik-form-module--loader--IMIqQ";
export var opaque = "formik-form-module--opaque--WjaNP";